import { render, staticRenderFns } from "./CargoPerfilV2.vue?vue&type=template&id=874f840e&scoped=true"
import script from "./CargoPerfilV2.vue?vue&type=script&lang=js"
export * from "./CargoPerfilV2.vue?vue&type=script&lang=js"
import style0 from "./CargoPerfilV2.vue?vue&type=style&index=0&id=874f840e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874f840e",
  null
  
)

export default component.exports